module.exports = __webpack_public_path__ + "static/media/How to convert File notes into Task.db0a9eca.png";